import { RankedTester, and, isStringControl, rankWith, optionIs } from "@jsonforms/core";

export const CustomColorPickerTester: RankedTester = rankWith(
  3,
  and(isStringControl, optionIs("colorPicker", true))
);

export default CustomColorPickerTester;
